import { SAVE_BILL_PDF_FAILURE, SAVE_BILL_PDF_REQUEST, SAVE_BILL_PDF_SUCCESS } from "../actionTypes"

export interface billDataState {
    loading  : boolean,
    billPdf : any,
    error : string
}

interface action {
    type : string
    payload : any
}

const initialState:billDataState = {
    loading  : false,
    billPdf : {},
    error : ""
}

export const saveBillPdfReducer = (state = initialState, action : action) => {
    switch(action.type){
        case SAVE_BILL_PDF_REQUEST : return {
            loading : true
        }
        case SAVE_BILL_PDF_SUCCESS : 
        return {
            loading : false,
            billPdf : action.payload,
            error : ""
        }
        case SAVE_BILL_PDF_FAILURE : return {
            loading : false,
            billPdf : {},
            error : action.payload
        }
        default : return state
    }
}